import { Loader, useAuthState } from '@gpt3/components';

const SignIn: React.FC = () => {
  window.location.replace(`${process.env.REACT_APP_AUTH_BASE_URL}/auth/login`);
  return null;
};

export default SignIn;
